import React from 'react'
import Modal from "react-modal";
import "./modal.css"
import { Button } from 'react-bootstrap';
import bookImage from "../../public/assets/noteFrame.svg"
import { useMyContext } from '../../myContext';
import CopyClipBoard from '../CopyClipboard/CopyClipBoard';

function CommonModal({ isOpen, onRequestClose, initiateTransfer, screen, detail, amount }) {
  const {themeColor} = useMyContext();

  return (
    <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    contentLabel="Modal"
    className={{
      base: "modal-base",
      afterOpen: "modal-base_after-open",
      beforeClose: "modal-base_before-close"
    }}
    overlayClassName={{
      base: "overlay-base",
      afterOpen: "overlay-base_after-open",
      beforeClose: "overlay-base_before-close"
    }}
    shouldCloseOnOverlayClick={true}
    closeTimeoutMS={500}
  >
    <div className='image-div'>
        {screen !== "offlineTransaction" && <img src={bookImage} alt="" style={{width: "78px", height: "78px"}}></img>}
    </div>
   {screen === "offlineTransaction" ? <div className='content-div'>
    <p className='para-heading' style={{color: "red", marginBottom: "20px"}}>Note: <span className='para-content' style={{textDecoration: "underline", marginLeft: "5px"}}>Please transfer INR {amount} to the Bank Account mentioned below:</span></p>
    <p className='para-heading'>Transaction - <span className='para-content'>{detail?.transactionId}</span> <CopyClipBoard value={detail?.transactionId}/></p>
    <p className='para-heading'>Name - <span className='para-content'>{detail?.name}</span> <CopyClipBoard value={detail?.name} /></p>
    <p className='para-heading'>Bank Name - <span className='para-content'>{detail?.bankName}</span> <CopyClipBoard value={detail?.bankName} /></p>
    <p className='para-heading'>Account Number - <span className='para-content'>{detail?.accountNumber}</span> <CopyClipBoard value={detail?.accountNumber} /></p>
    <p className='para-heading'>Ifsc Code - <span className='para-content'>{detail?.ifscCode}</span><CopyClipBoard value={detail?.ifscCode} /></p>
    </div> : <div className='content-div'>
    <p className="firstLine">Please ensure to complete the signing of A2 form and payment of the transaction amount in the next<span className='firstline-span'>30 minutes</span></p>
    </div>}
    <Button className='proceed-button' onClick={initiateTransfer} style={{background: themeColor, borderColor: themeColor}}>{screen === "offlineTransaction" ? "Proceed to Upload Documents" : "Proceed to transfer"}</Button>
    <Button className="removeButton" onClick={onRequestClose}>✕</Button>
  </Modal>
  )
}

export default CommonModal